var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table"},_vm._l((_vm.rows),function(row,index){return _c('table-row',{key:index,attrs:{"type":row.type,"gridless":row.gridless || false,"col1-content":row.content[0],"col2-content":row.content[1],"col3-content":row.content[2],"col4-content":row.content[3]}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }